import axios from "axios";

// =========================
// API Configuration
// =========================
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// =========================
// LOCAL BRANDING
// =========================
// Put these files inside:
// frontend-source/public/logo.png
// frontend-source/public/logo-dark.png
// frontend-source/public/hero.jpg
// frontend-source/public/mood.jpg
// =========================

export const LOGO_ICON = "/logo.png";

export const LOGO_DARK = "/logo-dark.png";

export const HERO_IMG = "/hero.jpg";

export const MOOD_IMG = "/mood.jpg";